import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import "../../assets/css/Studentinfo.css";

function StudentInfo() {
  const [activeTab, setActiveTab] = useState("profile");
  const [student, setStudent] = useState([]); // Initialize as null
  const [studentBranch, setStudentBranch] = useState(null);
  const [studentinvoice, setstudentinvoice] = useState([]);
  const [paymentDetails, setpaymentDetails] = useState([]);
  const [studentDariry, setStudentDairy] = useState([]);
  const [studentwork, setStudentwork] = useState([]);
  const rowBg = { backgroundColor: "#fceded" };
  const cellText = {
    fontSize: "14px",      // Same as td
    fontWeight: "400",     // Normal (not bold)
  };

  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const { id } = useParams();

  useEffect(() => {
    fetchDatas();
    invoicedetailsfetch();
    workhourfetch();
    totalhour();
  }, [id]); // Fetch data whenever id changes


  const invoicedetailsfetch = async () => {
    try {
      const response = await axios.get(apiUrl + `/studinginvoice/${id}`);
      console.log(
        "studinginvoice data from the server:",
        response.data
      );
      setstudentinvoice(response.data);
    }
    catch (error) {
      console.error("Error invoicedata data: ", error);
    }
  }



  const totalhour = async () => {
    try {
      const responsework = await axios.get(
        apiUrl + `/student_dairy_totalhour/${id}`
      );
      console.log("aaaaaa:", responsework.data.totalTime);
      setStudentwork(responsework.data.totalTime);
    } catch (error) {
      console.error("Error workfetch data: ", error);
    }
  }

  const workhourfetch = async () => {
    try {
      const responsedairy = await axios.get(
        apiUrl + `/student_dairy/${id}`
      );
      console.log("from the server:", responsedairy.data);
      setStudentDairy(responsedairy.data);
    } catch (error) {
      console.error("Error workfetch data: ", error);
    }
  }



  const fetchDatas = async () => {
    try {
      console.log("fetchDatas called");
      console.log("id is: ", id);

      // Fetching student data
      const responseStudent = await axios.get(apiUrl + `/students/${id}`);
      console.log("from the server:", responseStudent.data);
      setStudent(responseStudent.data);



      const responsepayment = await axios.get(
        apiUrl + `/studinginvoice/${id}`
      );
      console.log("from the server fees deatils:", responsepayment);
      console.log("from the server fees deatilsssssss:", responsepayment.data[0]?.invoice_details);
      setpaymentDetails(responsepayment.data[0]?.invoice_details)
      // Fetching student branch data
      const responseBranch = await axios.get(
        apiUrl + `/get_student_branch/${id}`
      );
      console.log("branch data from the server:", responseBranch.data);
      setStudentBranch(responseBranch.data);


    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // Log student data whenever it changes
  useEffect(() => {
    if (student) {
      console.log("The student data is: ", student);
    }
  }, [student]);
  const formatDateForInput = (isoDate) => {
    return new Date(isoDate).toISOString().split("T")[0]; // Extract YYYY-MM-DD
  };


  const navigate = useNavigate();

  return (
    <div className="marginup">
      {/* Breadcrumbs */}
      <div className="row">
        <div className="col-lg-11">
          <Link to="/dashboard" className="text-secondary dashBoard_text">
            <b>Dashboard / </b>
          </Link>
          <Link
            to="/Studyingstudents"
            className="text-secondary dashBoard_text"
          >
            <b>Studying Students / </b>
          </Link>
          <Link to="" className="text-danger dashBoard_text">
            <b>Profile</b>
          </Link>
        </div>
      </div>

      {/* Tabs */}
      <div className="row mt-2 ">
        <div className="col-lg-5">
          <h5>
            <b>Student Profile</b>
          </h5>
        </div>
        {/* <div className="col-lg-2"></div> */}
        <div className="col-lg-6 ">
          <div className="row">
            <div className="col-lg-3">
              <div
                className={`card cardeds ${activeTab === "profile" ? "bg-success" : "bg-secondary"
                  }`}
                onClick={() => handleTabClick("profile")}
              >
                <button className="btn text-white timeline">
                  <i className="fa-solid fa-user mx-1"></i> Profile
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              <div
                className={`card cardeds ${activeTab === "fees" ? "bg-success" : "bg-secondary"
                  }`}
                onClick={() => handleTabClick("fees")}
              >
                <button className="btn text-white timeline">
                  <i className="fa-solid fa-indian-rupee-sign mx-1"></i> Fees
                  Details
                </button>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className={`card cardeds ${activeTab === "timeline" ? "bg-success" : "bg-secondary"
                  }`}
                onClick={() => handleTabClick("timeline")}
              >
                <button className="btn text-white timeline">
                  <i className="fa-solid fa-hourglass-start mx-1"></i> Timeline
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-1">
          <div
            className={`card cardeds ${activeTab === "" ? "bg-success" : "bg-secondary"
              }`}
            onClick={() => navigate(`/singlepageview/${id}`)}
          >
            <button className="btn text-white timeline">
              <i class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>
      </div>


      {/* Student Details */}
      <div className="row mt-1 mb-4">
        <div className="col-lg-3 col-sm-3 col-md-3">
          <div className="card carddetails p-2">
            <div className="imgdetails">
              <img
                src={`${apiUrl}/uploads/${student.photo_upload || ""}`}
                alt=""
                className="img-fluid"
                style={{ height: "150px", width: "100%", objectFit: "contain" }}
              />
            </div>
            <div className="text-left mt-1 text-white">
              <h6 className="profile-details">
                <div className="row">
                  <div className="col-lg-2">
                    <i class="fa-solid fa-user"></i>
                  </div>
                  <div className="col-lg-10">
                    <b>{student.student_name_lead || ""}</b>
                  </div>
                </div>
              </h6>
              <h6 className="profile-details ">
                <div className="row ">
                  <div className="col-lg-2">
                    <i class="fa-solid fa-phone"></i>
                  </div>
                  <div className="col-lg-10">
                    {student.mobile_no_lead || ""}
                  </div>
                </div>
              </h6>
              <h6 className="profile-details">
                <div className="row">
                  <div className="col-lg-2">
                    <i class="fa-solid fa-id-card"></i>
                  </div>
                  <div className="col-lg-10">{student.roll_no || ""}</div>
                </div>
              </h6>
              <h6 className="profile-details">
                <div className="row">
                  <div className="col-lg-2">
                    <i class="fa-solid fa-book"></i>
                  </div>
                  <div className="col-lg-10">
                    {student.Prefered_course_lead || ""}
                  </div>
                </div>
              </h6>
            </div>
          </div>

          <div className="card carddetails p-1 mt-3">
            {student?.datelist?.length > 0 ? (
              <>
                <div className="row details-datas">
                  <div className="col-lg-6 mt-1" style={{ paddingLeft: "30px" }}>
                    <b>EMI Date</b>
                  </div>
                  <div className="col-lg-6 mt-1 pb-1">
                    <b>EMI Amount</b>
                  </div>
                </div>

                {student.datelist.map((date, index) => (
                  <div className="row details-datas" key={index}>
                    <div className="col-lg-6 mt-1" style={{ paddingLeft: "20px" }}>
                      <p>{formatDateForInput(date)}</p>
                    </div>
                    <div className="col-lg-6">
                      <p>{student.emilist[index]}</p>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="row">
                <div className="col-lg-6">
                  <b>EMI Date</b>
                </div>
                <div className="col-lg-6">
                  <b>EMI Amount</b>
                </div>

                <p className="mt-4">There is No Installment</p>
              </div>
            )}
          </div>
        </div>

        {/* Profile Information */}
        <div
          className={`${activeTab === "profile"
            ? "col-lg-6 col-sm-6 col-md-6"
            : "d-none"
            }`}
        >
          <div className="card cardborder p-1">
            <div className="row p-1">
              <div className="col-lg-6 col-md-6 col-sm-6 text-danger">
                <b>Profile Info</b>
              </div>
            </div>
          </div>

          <div className="card cardborder">
            <div className="p-2">
              <table className="table table-borderless table-sm mb-0">
                <tbody>
                  <tr>
                    <th style={{ ...rowBg, ...cellText }}>Branch</th>
                    <td style={{ ...rowBg, ...cellText }}>
                      {student.branch_lead?.branch_name || ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{...cellText }}>Registration No</th>
                    <td>
                      {student.register_no || ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{ ...rowBg, ...cellText }}>Father Name</th>
                    <td style={{ ...rowBg, ...cellText }}>
                      {student.father_name || ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{...cellText }}>Qualification</th>
                    <td>
                      {student.qualification || ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{ ...rowBg, ...cellText }}>Course Category</th>
                    <td style={{ ...rowBg, ...cellText }}>
                      {student.category || ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{...cellText }}>Batch Timings</th>
                    <td style={{...cellText }}>
                      {student.batch_timings || ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{ ...rowBg, ...cellText }}>Admission Date</th>
                    <td  style={{ ...rowBg, ...cellText }}>
                      {student.admission_date
                        ? new Date(student.admission_date).toLocaleDateString("en-CA")
                        : ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{...cellText }}>Date of Birth</th>
                    <td style={{...cellText }}>
                      {student.date_of_birth
                        ? new Date(student.date_of_birth).toLocaleDateString("en-CA")
                        : ""}
                    </td>
                  </tr>

                  <tr>
                    <th  style={{ ...rowBg, ...cellText }}>Enquiry Date</th>
                    <td  style={{ ...rowBg, ...cellText }}>
                      {student.Enquiry_date_lead
                        ? new Date(student.Enquiry_date_lead).toLocaleDateString("en-CA")
                        : ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{...cellText }}>Email</th>
                    <td style={{...cellText }}>
                      {student.email_lead || ""}
                    </td>
                  </tr>

                  <tr>
                    <th  style={{ ...rowBg, ...cellText }}>Enquiry Purpose</th>
                    <td  style={{ ...rowBg, ...cellText }}>
                      {student.purpose_enquiry_lead || ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{...cellText }}>Source Type</th>
                    <td style={{...cellText }}>
                      {student.Source_type_lead || ""}
                    </td>
                  </tr>

                  <tr>
                    <th  style={{ ...rowBg, ...cellText }}>Trainer</th>
                    <td  style={{ ...rowBg, ...cellText }}>
                      {student.trainer || ""}
                    </td>
                  </tr>

                  <tr>
                    <th style={{...cellText }}>Placements</th>
                    <td>
                      {student.placement || ""}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Fees and Timeline tabs (Placeholder) */}
        <div
          className={`${activeTab === "fees" ? "col-lg-6 col-sm-6 col-md-6" : "d-none"
            }`}
        >
          <div className="row cardborder ">
            <div className="card cardborder p-1">
              <div className="row p-2">
                <div className="col-lg-6">
                  <b>Fees Details</b>
                </div>
              </div>
            </div>
            <div className="card cardborder">
              <table className="table table-striped responsive">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date </th>
                    <th>Paid</th>
                    <th>Pay Type</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentDetails.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{formatDatefitching(item.date)}</td>


                        <td>{item.paid}</td>
                        <td>{item.paytype}</td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          className={`${activeTab === "timeline" ? "col-lg-6 col-sm-6 col-md-6" : "d-none"
            }`}
        >
          <div className="row cardborder ">
            <div className="card cardborder p-1">
              <div className="row p-2">
                <div className="col-lg-6">
                  <b>Timeline</b>
                </div>
              </div>
            </div>
            <div className="card cardborder">
              <table className="table table-striped responsive">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date </th>
                    <th>Login</th>
                    <th>logOut</th>
                    <th>Topic</th>
                    <th>Sub Topic</th>
                    <th>Total Hour</th>
                  </tr>
                </thead>
                <tbody>
                  {studentDariry.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{formatDatefitching(item.date)}</td>
                        <td>{item.login}</td>

                        <td>{item.logout}</td>
                        <td>{item.topic_covered}</td>
                        <td>{item.subtopic}</td>
                        <td>{item.totalhour}</td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-3 col-md-3">
          <div className="card carddetails p-1">
            <div className="imgdetails">
              <img
                src={`${apiUrl}/uploads/${student.id_proof || ""}`}
                alt=""
                className="img-fluid"
                style={{ height: "150px", width: "100%", objectFit: "contain" }}
              />
            </div>
          </div>

          <div className="card carddetails p-1">
            <div className="row">
              <div className="col-lg-12 text-danger">
                <b>Payment / Duration</b>
              </div>
            </div>
          </div>

          <div className="card carddetails details-data_overall p-1">
            <div>
              <table className="table table-striped table-borderless table-sm mb-0">
                <tbody>
                  <tr>
                    <th>Total Fees</th>
                    <td>
                      {student.fees || ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Paid</th>
                    <td>
                      {studentinvoice[0]?.invoice_details[0]?.paid || ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Balance</th>
                    <td>
                      {studentinvoice[0]?.invoice_details[0]?.balance || ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Discount</th>
                    <td>
                      {student.discount || ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Duration</th>
                    <td>
                      {student.duraction || ""}
                    </td>
                  </tr>

                  <tr>
                    <th>Total Hour</th>
                    <td>
                      {studentwork || "0"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-lg-12 col-sm-12 col-md-12 mt-1">
            <div className="card cardborder ">
              <b className="text-danger p-1">Topics Covered</b>
            </div>
            <div className="card cardborder p-1 Completed-profile">
              {studentDariry.map((item, index) => (
                <>
                  <tr key={index}>
                    <td>{item.topic_covered}</td>
                  </tr>
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentInfo;

// /\/\/\/\/\/\/\/\/\//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\ //

// import React, { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import axios from "axios";
// import apiUrl from "../../environment/Api";
// import "../../assets/css/Studentinfo.css";

// function StudentInfo() {
//   const [activeTab, setActiveTab] = useState("profile");
//   const [student, setStudent] = useState([]); // Initialize as null
//   const [studentBranch, setStudentBranch] = useState(null);
//   const [studentinvoice, setstudentinvoice] = useState([]);
//   const [paymentDetails, setpaymentDetails] = useState([]);
//   const [studentDariry, setStudentDairy] = useState([]);

//   const formatDatefitching = (isoDate) => {
//     if (!isoDate) return ""; // Return an empty string if no date is provided
//     const date = new Date(isoDate);
//     return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
//   };

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   const { id } = useParams();

//   useEffect(() => {
//     fetchDatas();
//   }, [id]); // Fetch data whenever id changes

//   const fetchDatas = async () => {
//     try {
//       console.log("fetchDatas called");
//       console.log("id is: ", id);

//       // Fetching student data
//       const responseStudent = await axios.get(apiUrl + `/students/${id}`);
//       console.log("from the server:", responseStudent.data);
//       setStudent(responseStudent.data);

//       const responsedairy = await axios.get(
//         apiUrl + `/student_dairy_studentid/${id}`
//       );
//       console.log("from the server:", responsedairy.data);
//       setStudentDairy(responsedairy.data);
//       // Fetching student branch data
//       const responseBranch = await axios.get(
//         apiUrl + `/get_student_branch/${id}`
//       );
//       console.log("branch data from the server:", responseBranch.data);
//       setStudentBranch(responseBranch.data);

//       const response = await axios.get(apiUrl + `/studinginvoice/${id}`);
//       console.log(
//         "studinginvoice data from the server:",
//         response.data[0].father_name
//       );
//       console.log("studinginvoice data from the server:", response.data);
//       setstudentinvoice(response.data);
//     } catch (error) {
//       console.error("Error fetching data: ", error);
//     }
//   };

//   // Log student data whenever it changes
//   useEffect(() => {
//     if (student) {
//       console.log("The student data is: ", student);
//     }
//   }, [student]);

//   return (
//     <>
//       <div className="marginup">
//         {/* Breadcrumbs */}
//         <div className="row">
//           <div className="col-lg-11">
//             <Link to="/dashboard" className="text-secondary dashBoard_text">
//               <b>Dashboard / </b>
//             </Link>
//             <Link
//               to="/Studyingstudents"
//               className="text-secondary dashBoard_text"
//             >
//               <b>Studying Students / </b>
//             </Link>
//             <Link to="" className="text-danger dashBoard_text">
//               <b>Profile</b>
//             </Link>
//           </div>
//         </div>

//         <h5>
//           <b>Student Profile</b>
//         </h5>

//         {/* Student Details */}
//         <div className="row mt-4 mb-4">
//           <div className="col-lg-3 col-sm-3 col-md-3">
//             <div className="card carddetails p-2">
//               <div className="imgdetails">
//                 <img
//                   src={`${apiUrl}/uploads/${student.photo_upload || ""}`}
//                   alt=""
//                   className="img-fluid"
//                   style={{
//                     height: "200px",
//                     width: "100%",
//                     objectFit: "contain",
//                   }}
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9 col-md-9 col-sm-12">
//             <div className="card p-3">
//               <div className="row">
//                 <div className="col-lg-6">
//                   <div className="row mb-4">
//                     {/* <i className="fa-solid fa-user text-secondary me-2"></i> */}
//                     <h6 className="text-secondary m-0">Name:</h6>
//                     <input
//                       className="input_inside"
//                       disabled
//                       value={student.student_name_lead || ""}
//                       placeholder="No name available"
//                       style={{width: '90%', marginLeft: '10px'}}
//                     />
//                     {/* <b>{student.student_name_lead || ""}</b> */}
//                   </div>

//                   <div className="row mb-4">
//                     {/* <i class="fa-solid fa-phone text-secondary me-2"></i> */}
//                     <h6 className="text-secondary m-0">Mobile:</h6>
//                     <input
//                       className="input_inside"
//                       disabled
//                       value={student.mobile_no_lead || ""}
//                       placeholder="No name available"
//                       style={{width: '90%', marginLeft: '10px'}}
//                     />

//                     {/* <b>{student.mobile_no_lead || ""}</b> */}
//                   </div>

//                   <div className="row">
//                     {/* <i class="fa-solid fa-id-card text-secondary me-2"></i> */}

//                     <h6 className="text-secondary m-0">Roll No:</h6>
//                     <input
//                       className="input_inside"
//                       disabled
//                       value={student.roll_no || ""}
//                       placeholder="No name available"
//                       style={{width: '90%', marginLeft: '10px'}}
//                     />

//                     {/* <b>{student.roll_no || ""}</b> */}
//                   </div>
//                 </div>

//                 <div className="col-lg-6">
//                   <div className="row mb-4">
//                     {/* <i class="fa-solid fa-phone text-secondary me-2"></i> */}
//                     <h6 className="text-secondary m-0">Register No:</h6>
//                     <input
//                       className="input_inside"
//                       disabled
//                       value={student.register_no || ""}
//                       placeholder="No name available"
//                       style={{width: '90%', marginLeft: '10px'}}
//                     />

//                     {/* <b>{student.register_no || ""}</b> */}
//                   </div>

//                   <div className="row mb-4">
//                     {/* <i class="fa-solid fa-book text-secondary me-2"></i> */}
//                     <h6 className="text-secondary m-0">Course:</h6>
//                     <input
//                       className="input_inside"
//                       disabled
//                       value={student.Prefered_course_lead || ""}
//                       placeholder="No name available"
//                       style={{width: '90%', marginLeft: '10px'}}
//                     />

//                     {/* <b>{student.Prefered_course_lead || ""}</b> */}
//                   </div>

//                   <div className="row">
//                     {/* <i class="fa-solid fa-phone text-secondary me-2"></i> */}
//                     <h6 className="text-secondary m-0">User Id:</h6>
//                     <input
//                       className="input_inside"
//                       disabled
//                       value={student.student_user_id || ""}
//                       placeholder="No name available"
//                       style={{width: '90%', marginLeft: '10px'}}
//                     />

//                     {/* <b>{student.student_user_id || ""}</b> */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <h6 className="">Profile Details</h6>

//         <div className="row mb-3">
//           <div className="col-lg-9">
//             <div className="card p-3">
//               <div className="row">
//                 <div className="col-lg-6">
//                   <div className=" p-2">
//                     <div className="row p-1">
//                       <div className="col-lg-5 text-secondary">Branch</div>
//                       <div className="col-lg-6">
//                         <strong>
//                           {student.branch_lead?.branch_name || ""}
//                         </strong>
//                       </div>
//                     </div>
//                     <div className="row p-1">
//                       <div className="col-lg-5 text-secondary">
//                         Registration No
//                       </div>
//                       <div className="col-lg-6">
//                         <strong>{student.register_no || ""}</strong>
//                       </div>
//                     </div>
//                     <div className="row p-1">
//                       <div className="col-lg-5 text-secondary">Father Name</div>
//                       <div className="col-lg-6">
//                         <strong>{student.father_name || ""}</strong>
//                       </div>
//                     </div>
//                     <div className="row mt-1 p-1">
//                       <div className="col-lg-5 text-secondary">
//                         Qualification
//                       </div>
//                       <div className="col-lg-6">
//                         <strong>{student.qualification || ""}</strong>
//                       </div>
//                     </div>
//                     <div className="row mt-1 p-1">
//                       <div className="col-lg-5 text-secondary">Category</div>
//                       <div className="col-lg-6">
//                         <strong>{student.category || ""}</strong>
//                       </div>
//                     </div>
//                     <div className="row mt-1 p-1">
//                       <div className="col-lg-5 text-secondary">
//                         Batch Timings
//                       </div>
//                       <div className="col-lg-6">
//                         <strong>{student.batch_timings || ""}</strong>
//                       </div>
//                     </div>
//                     <div className="row mt-1 p-1">
//                       <div className="col-lg-5 text-secondary">
//                         Admission Date
//                       </div>
//                       <div className="col-lg-6">
//                         <strong>
//                           {student.admission_date
//                             ? new Date(
//                                 student.admission_date
//                               ).toLocaleDateString("en-CA")
//                             : ""}
//                         </strong>
//                       </div>
//                     </div>
//                     <div className="row p-1">
//                       <div className="col-lg-5 text-secondary">
//                         Date of Birth
//                       </div>
//                       <div className="col-lg-6">
//                         <strong>
//                           {student.date_of_birth
//                             ? new Date(
//                                 student.date_of_birth
//                               ).toLocaleDateString("en-CA")
//                             : ""}
//                         </strong>
//                       </div>
//                     </div>

//                     <div className="row p-1">
//                       <div className="col-lg-5 text-secondary">
//                         Enquiry Date
//                       </div>
//                       <div className="col-lg-6">
//                         <strong>
//                           {student.Enquiry_date_lead
//                             ? new Date(
//                                 student[0]?.Enquiry_date_lead
//                               ).toLocaleDateString("en-CA")
//                             : ""}
//                         </strong>
//                       </div>
//                     </div>
//                     <div className="row p-1">
//                       <div className="col-lg-5 text-secondary">Email</div>
//                       <div className="col-lg-6">
//                         <strong>{student.email_lead || ""}</strong>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-lg-6">
//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">
//                       Enquiry Purpose
//                     </div>
//                     <div className="col-lg-6">
//                       <strong>{student.purpose_enquiry_lead || ""}</strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Source Type</div>
//                     <div className="col-lg-6">
//                       <strong>{student.Source_type_lead || ""}</strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Trainer</div>
//                     <div className="col-lg-6">
//                       <strong>{student.trainer || ""}</strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Placements</div>
//                     <div className="col-lg-6">
//                       <strong>{student.placement || ""}</strong>
//                     </div>
//                   </div>

//                   {/* /\/\/\/\//\/\/\/\/\/\/\/\/\/\/ */}

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Total Fees</div>
//                     <div className="col-lg-6">
//                       <strong>{student.fees || ""}</strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Paid</div>
//                     <div className="col-lg-6">
//                       <strong>{student.fees || ""}</strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Total Fees</div>
//                     <div className="col-lg-6">
//                       <strong>
//                         {studentinvoice[0]?.invoice_details[0]?.paid}
//                       </strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Balance</div>
//                     <div className="col-lg-6">
//                       <strong>
//                         {studentinvoice[0]?.invoice_details[0]?.balance}
//                       </strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Discount</div>
//                     <div className="col-lg-6">
//                       <strong> {student.discount || ""}</strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">
//                       Course Duration
//                     </div>
//                     <div className="col-lg-6">
//                       <strong>{student.duraction_time || "0"}</strong>
//                     </div>
//                   </div>

//                   <div className="row mt-1 p-1">
//                     <div className="col-lg-5 text-secondary">Duration</div>
//                     <div className="col-lg-6">
//                       <strong>{student.duraction || ""}</strong>
//                     </div>
//                   </div>

//                   {/* /\/\/\/\//\/\/\/\/\/\/\/\/\/\/ */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-3">
//             {/* <h6 className="">Id Proof</h6> */}
//             <div className="card carddetails p-1 mb-3">
//               <div className="imgdetails">
//                 <img
//                   src={`${apiUrl}/uploads/${student.id_proof || ""}`}
//                   alt=""
//                   className="img-fluid"
//                   style={{
//                     height: "200px",
//                     width: "100%",
//                     objectFit: "contain",
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <h6 className="">Fees Details</h6>
//         <div className="row mb-5">
//           <div className="card cardborder p-3">
//             <table className="table table-striped responsive">
//               <thead>
//                 <tr>
//                   <th>S.No</th>
//                   <th>Branch</th>
//                   <th>Date </th>
//                   <th>Paid</th>
//                   <th>Pay Type</th>
//                   <th>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paymentDetails.map((item, index) => (
//                   <>
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td></td>
//                       <td>{formatDatefitching(item.date)}</td>
//                       <td>
//                         {item.course_id}-{item.details}
//                       </td>
//                       <td>{item.paid}</td>
//                       <td>{item.paytype}</td>
//                       <td></td>
//                     </tr>
//                   </>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <h6 className="">Timeline Details</h6>

//         <div className="row mb-5">
//           <div className="card cardborder p-3">
//             <table className="table table-striped responsive">
//               <thead>
//                 <tr>
//                   <th>S.No</th>
//                   <th>Date </th>
//                   <th>Login</th>
//                   <th>logOut</th>
//                   <th>Topic</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {studentDariry.map((item, index) => (
//                   <>
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>{formatDatefitching(item.date)}</td>
//                       <td>{item.login}</td>

//                       <td>{item.logout}</td>
//                       <td>{item.topic_covered}</td>
//                     </tr>
//                   </>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default StudentInfo;
